import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3f964cd0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teaching-intro-container"
};
const _hoisted_2 = {
  class: "tabs-list"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  key: 0,
  class: "content"
};
const _hoisted_7 = {
  class: "detail-title"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "detail-title"
};
const _hoisted_10 = {
  class: "detail-content"
};
const _hoisted_11 = {
  class: "detail-title"
};
const _hoisted_12 = {
  class: "detail-content"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["id"];
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = {
  key: 0,
  class: "team-leader"
};
const _hoisted_18 = {
  class: "leader-num"
};
const _hoisted_19 = {
  class: "text"
};
const _hoisted_20 = {
  class: "num"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "位", -1));

const _hoisted_22 = {
  class: "leader-list"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "photo"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  class: "leader-info"
};
const _hoisted_27 = {
  class: "name"
};
const _hoisted_28 = {
  class: "leader-title"
};
import { getUrlParams } from '@/plugins/utils';
import { ZhsSvgIcon } from 'zhs-component-library';
import FileItem from './fileInfo.vue';
import VideoBox from '@/components/FilePreview/VideoPreview.vue';
export default {
  props: {
    menu: Object,
    groupBasicInfo: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const activeItem = ref('');

    const onAnchorChange = href => {
      activeItem.value = href ? href : activeItem.value;
    };

    const onAnchorClick = (e, link) => {
      console.log(e, link);
      e.preventDefault();
      activeItem.value = link.href;
    };

    const basicInfo = [{
      columnContent: props.groupBasicInfo.introduction
    }]; // 菜单栏目列表

    const siteId = getUrlParams('groupSiteId');
    const menuList = ref([]);
    const columnIds = ref('');
    const teamColumnId = ref('');
    const columnDetailList = ref(null);

    const getMenuList = async () => {
      const res = await $http.getGroupMenuList({
        site_id: siteId
      });
      console.log('课程组菜单列表', res);
      menuList.value = res.filter(item => item.status == 1);
      activeItem.value = '#' + menuList.value[0].column_id;
      const baseIndex = menuList.value.findIndex(item => item.column_type === 50);

      if (baseIndex !== -1) {
        menuList.value[baseIndex].column_detail = basicInfo;
      }

      let columsIdList = [];
      menuList.value.map(item => {
        if (item.column_type !== 51 && item.column_type !== 50) {
          columsIdList.push(item.column_id);
        }

        if (item.column_type == 51) {
          teamColumnId.value = item.column_id;
        }
      });
      columnIds.value = columsIdList.join(',');
      getColumsDetail(columnIds.value);
      getTeamList();
    };

    getMenuList(); // 栏目详情，批量

    const getColumsDetail = async ids => {
      const detail = await $http.getColunmDetails({
        column_ids: ids
      });
      let listArr = menuList.value; // 将详情数据放到对应的栏目信息里

      Object.keys(detail).map(i => {
        listArr.forEach(item => {
          if (item.column_id == i) {
            item.column_detail = detail[i];
          }
        });
      });
      columnDetailList.value = listArr;
      console.log('栏目详情', columnDetailList.value);
    }; // 获取团队成员列表


    const teamList = ref([]);

    const getTeamList = async () => {
      const team = await $http.getGroupTeamList({
        column_id: teamColumnId.value
      });
      console.log('team', team);
      teamList.value = team;
    };

    const goMemberDetail = id => {
      const source = getUrlParams('source');
      const name = getUrlParams('name');

      if (source === 'teachCenter') {
        // 来源教研中心
        window.location.href = `/groupMemberDetail.html?id=${id}&source=${source}&name=${name}`;
      } else {
        window.location.href = `/groupMemberDetail.html?id=${id}&menuId=${props.menu.menu_id}&name=${props.menu.nav_name}`;
      }
    };

    return (_ctx, _cache) => {
      const _component_a_anchor_link = _resolveComponent("a-anchor-link");

      const _component_a_anchor = _resolveComponent("a-anchor");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_anchor, {
        affix: true,
        onChange: onAnchorChange,
        onClick: onAnchorClick,
        wrapperClass: "anchor-wrapper",
        showInkInFixed: true,
        offsetTop: 30
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, i) => {
          return _openBlock(), _createBlock(_component_a_anchor_link, {
            class: _normalizeClass(["tab", activeItem.value == '#' + item.column_id ? 'active-item' : '']),
            key: item.column_id,
            title: item.column_title,
            href: '#' + item.column_id
          }, null, 8, ["title", "href", "class"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnDetailList.value, (menu, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "menu-content",
          key: index
        }, [menu.column_type !== 51 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: menu.column_id,
          class: "intro-box"
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ZhsSvgIcon), {
          name: "xiaosanjiao",
          color: "var(--el-color-primary)",
          iconClass: "sanjiao-svg"
        }), _createTextVNode(" " + _toDisplayString(menu.column_title), 1)]), menu.column_type !== 50 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.column_detail, detail => {
          return _openBlock(), _createElementBlock("div", {
            class: "detail-item",
            key: detail.id
          }, [detail.columnType == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_7, _toDisplayString(detail.columnTitle), 1), _createElementVNode("div", {
            class: "detail-content",
            "data-html": "",
            innerHTML: detail.columnContent
          }, null, 8, _hoisted_8)], 64)) : _createCommentVNode("", true), detail.columnType == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_9, _toDisplayString(detail.columnTitle), 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.files, file => {
            return _openBlock(), _createBlock(FileItem, {
              key: file.fileId,
              fileInfo: file
            }, null, 8, ["fileInfo"]);
          }), 128))])], 64)) : _createCommentVNode("", true), detail.columnType == 4 || detail.columnType == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("div", _hoisted_11, _toDisplayString(detail.columnTitle), 1), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.files, file => {
            return _openBlock(), _createBlock(VideoBox, {
              class: "video-item",
              key: file.fileId,
              videoUrl: file.fileUrl,
              coverUrl: file.coverUrl
            }, null, 8, ["videoUrl", "coverUrl"]);
          }), 128))])], 64)) : _createCommentVNode("", true)]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "content",
          "data-html": "",
          innerHTML: menu.column_detail[0].columnContent
        }, null, 8, _hoisted_13))], 8, _hoisted_4)) : _createCommentVNode("", true), menu.column_type == 51 ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: menu.column_id,
          class: "intro-box"
        }, [_createElementVNode("div", _hoisted_15, [_createVNode(_unref(ZhsSvgIcon), {
          name: "xiaosanjiao",
          color: "var(--el-color-primary)",
          iconClass: "sanjiao-svg"
        }), _createTextVNode(" " + _toDisplayString(menu.column_title), 1)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamList.value, team => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: team.id
          }, [team.members && team.members.length ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(team.name), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(team.members.length), 1), _hoisted_21])]), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.members, member => {
            return _openBlock(), _createElementBlock("div", {
              class: "leader-item",
              key: member.id,
              onClick: $event => goMemberDetail(member.id)
            }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
              src: member.avatarUrl || require('@/assets/images/user_avatar.jpg'),
              alt: ""
            }, null, 8, _hoisted_25)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(member.userName), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(member.title), 1)])], 8, _hoisted_23);
          }), 128))])])) : _createCommentVNode("", true)], 64);
        }), 128))])], 8, _hoisted_14)) : _createCommentVNode("", true)]);
      }), 128))])]);
    };
  }

};